"use strict";

import tippy, {hideAll} from "tippy.js";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", function () {
	const regionalContainer = document.querySelector("#regional");

	const tippyContent = (el, instance) => {
		const title = el.dataset.title;
		const projects = el.dataset.projects;
		const link = el.dataset.link;
		const location = el.dataset.location;
		const phone = el.dataset.phone

		const dividerEl = (location !== "" || phone !== "") ? "<hr class='regional__tip-divider'>" : "";
		const locationEl = (location !== "") ? `<div class='regional__tip-location'>${location}</div>` : "";
		const phoneEl = (phone !== "") ? `<a className='regional__tip-phone' href='tel:${phone}'>${phone}</a>` : "";

		instance.setContent(`<div class='regional__tip'>
													 <div class='regional__tip-title'>${title}</div>
													 <a class='regional__tip-projects' href=${link}>${projects}</a>
													 ${dividerEl}
													 ${locationEl}
													 ${phoneEl}
												 </div>`);
	}

	if (regionalContainer) {
		const regionalSpacer = document.querySelector("#regionalSpacer");
		const regionalMap = document.querySelector("#regionalMap");
		const scrollTriggerOptions = {
			trigger: regionalSpacer,
			start: 'top top',
			end: `${window.innerHeight} end`,
			invalidateOnRefresh: true,
			scrub: 1,
		}

		tippy("[data-tippy]", {
			arrow: false,
			allowHTML: true,
			maxWidth: 208,
			placement: 'right-end',
			interactive: true,
			interactiveBorder: 5,
			appendTo: () => document.body,
			onShow(instance) {
				hideAll();
				tippyContent(instance.reference, instance);
			},
		});

		let mm = gsap.matchMedia()
		mm.add("(min-width: 1025px)", () => {
			ScrollTrigger.create({
				trigger: regionalSpacer,
				pin: regionalSpacer,
				start: 'top top',
				end: `${window.innerHeight * 1.5} end`,
				invalidateOnRefresh: true,
				scrub: 1,
			});

			gsap.to(regionalMap, {
				scrollTrigger: scrollTriggerOptions,
				scale: 1.328,
				x: 360,
				y: -110,
				ease: 'none'
			})

			gsap.to(regionalContainer, {
				scrollTrigger: scrollTriggerOptions,
				backgroundColor: "#ddeaec",
				ease: 'none'
			})
		})

		const regionalLinks = document.querySelectorAll(".main__link");
		if (regionalLinks.length) {
			regionalLinks.forEach((link) => {
				const linkTarget = link.dataset.target;
				const pin = regionalMap.querySelector("#" + linkTarget);
				let instance = tippy(link, {
					arrow: false,
					allowHTML: true,
					maxWidth: 208,
					placement: 'right-end',
					interactive: true,
					interactiveBorder: 5,
					trigger: 'click',
					appendTo: () => document.body,
					onShow(instance) {
						hideAll();
						tippyContent(pin, instance);
					},
				});

				link.addEventListener("click", function () {
					regionalSpacer.scrollIntoView({behavior: "smooth"});
					instance.setProps({
						getReferenceClientRect: () => ({
							width: 0,
							height: 0,
							top: pin.getBoundingClientRect().top,
							bottom: pin.getBoundingClientRect().bottom,
							left: pin.getBoundingClientRect().left,
							right: pin.getBoundingClientRect().right,
						}),
					});
					instance.show();
				})
			})
		}
	}
})
